export const LIBRARY = 'header.library';
export const ACCOUNT = 'header.account';
export const LOGOUT = 'header.logout';
export const SETTINGS = 'header.settings';
